import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';
import { Shield, XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const { user } = useAuth();
  const dashboardLink = user?.account_type === 'employer' ? '/employer/dashboard' : '/employee/dashboard';

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#F5F8FF' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-3">
            <div style={{ 
              width: '44px', 
              height: '44px', 
              background: 'linear-gradient(120deg, #1B5AFF, #00C9A7)', 
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Shield className="h-6 w-6 text-white" />
            </div>
            <span style={{ 
              fontSize: '24px', 
              fontWeight: 800, 
              color: '#0A0F1E',
              fontFamily: "'Bricolage Grotesque', sans-serif"
            }}>VETT</span>
          </Link>
        </div>

        <Card style={{ 
          background: '#FFFFFF', 
          border: '1px solid #E8EDF5', 
          borderRadius: '16px', 
          padding: '32px',
          textAlign: 'center'
        }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            borderRadius: '50%', 
            background: 'rgba(229, 72, 77, 0.15)', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            margin: '0 auto 16px'
          }}>
            <XCircle className="h-10 w-10" style={{ color: '#E5484D' }} />
          </div>
          <h1 style={{ 
            fontSize: '24px', 
            fontWeight: 700, 
            color: '#0A0F1E',
            fontFamily: "'Bricolage Grotesque', sans-serif",
            marginBottom: '8px'
          }}>Payment Cancelled</h1>
          <p style={{ color: '#5B6472', marginBottom: '24px', fontFamily: "'Bricolage Grotesque', sans-serif" }}>
            Your payment was cancelled. No charges were made.
          </p>
          <div className="flex gap-3 justify-center">
            <Link to={dashboardLink}>
              <Button 
                variant="outline" 
                style={{ 
                  border: '1px solid #E8EDF5',
                  color: '#0A0F1E',
                  borderRadius: '10px',
                  fontFamily: "'DM Mono', monospace",
                  fontWeight: 500
                }}
              >
                Go to Dashboard
              </Button>
            </Link>
            <Link to={user?.account_type === 'employer' ? '/employer/settings' : '/employee/settings'}>
              <Button style={{ 
                background: 'linear-gradient(120deg, #1B5AFF, #00C9A7)',
                color: '#FFFFFF',
                borderRadius: '10px',
                fontFamily: "'DM Mono', monospace",
                fontWeight: 500
              }}>
                Try Again
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;
